module.exports = __webpack_public_path__ + "download/img/healthylife.c9c7b249.png";